var _circle, _g, _circle2, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_1777_4797)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1777_4797)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 12,
    fill: "url(#paint1_linear_1777_4797)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 12,
    fill: "url(#paint2_radial_1777_4797)",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1777_4797",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 12,
    fill: "url(#paint3_radial_1777_4797)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1777_4797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5001 14.5C26.0001 19.5 19.5001 18 17.0001 14C17.0001 14 15.6452 15.0162 15.5001 15.5C14.0001 20.5 27.5001 24.5 33.0001 15.5L31.5001 14.5Z",
    fill: "#D35050",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5001 26C22.0001 27.5 12 22.5 13 17.5C13 17 10.8837 21.3025 11 22C12.0001 28 24.5905 33.307 33 27C35 25.5 37 23 36.5 21C35.3 23.8 31.6789 25.792 30.5001 26Z",
    fill: "#D35050",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 28.5C25.5 33.5 18.4999 33.5 13.9999 31.5C15.4999 33.5 17.3982 34.1991 18 34.5C20 35.5 29.5 34.5 35.4999 28.5Z",
    fill: "#D35050",
    fillOpacity: 0.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9469 28.4503C12.8391 28.2857 12.7424 28.0955 12.6555 27.878C8.99671 30.4341 6.87709 32.4865 7.31461 33.2768C8.07392 34.6482 16.2475 31.6987 25.5709 26.6889C34.8942 21.6792 41.8368 16.5062 41.0774 15.1348C40.6372 14.3396 37.7043 14.9971 33.4999 16.6666C33.6949 16.919 33.8764 17.1715 34.0457 17.4211C35.146 17.1617 35.8525 17.1621 36.0249 17.4734C36.5779 18.4723 31.4215 22.2936 24.5078 26.0086C17.594 29.7236 11.541 31.9255 10.988 30.9266C10.7595 30.514 11.5054 29.6197 12.9469 28.4503Z",
    fill: "url(#paint4_linear_1777_4797)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1777_4797",
    x: 4,
    y: 4,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.594833 0 0 0 0 0.220833 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_4797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_4797",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.875333 0 0 0 0 0.816667 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect2_innerShadow_1777_4797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1777_4797",
    x1: 27.5,
    y1: 51.5,
    x2: 27.4662,
    y2: -6.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F2968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1777_4797",
    x1: 31.8,
    y1: 36,
    x2: 16.2,
    y2: 15.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#211539",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFEE53",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1777_4797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 28.8) rotate(-109.799) scale(15.9424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF2121",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F50",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1777_4797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 28.8) rotate(-109.799) scale(15.9424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F50",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1777_4797",
    x1: 36,
    y1: 14,
    x2: 23.8369,
    y2: 9.95204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0328256,
    stopColor: "#FFF6E6",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411561,
    stopColor: "white",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE6BB",
    stopOpacity: 0.93
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolNew);
export default __webpack_public_path__ + "static/media/symbol-new.103ffc59225a2d53693223526eeaa29e.svg";
export { ForwardRef as ReactComponent };